module.exports = __webpack_public_path__ + "7d39e702db520b76d81da56f7b477899.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/routes/Confirmation/vcc@2x.png
// module id = 1053
// module chunks = 0